import { FC } from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { Theme } from "@liquid-design/liquid-design-react";
import { UserContextProvider } from "services/auth";

import store from "store";

import Pages from "./pages";

const App: FC = () => {
  return (
    <BrowserRouter>
    <Provider store={store}>
        <UserContextProvider
          domainHint="merckgroup.com"
          clientId={process.env.REACT_APP_CLIENT_ID || ""}
        >
          <Theme
            id="theme"
            className="ld-theme-bubblegum inset-0 flex flex-col max-h-full"
            themeName="vibrantCyan"
          >
            <Pages />
          </Theme>
        </UserContextProvider>
      
    </Provider>
    </BrowserRouter>
  );
};

export default App;
